module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_15.5cce5bef.jpg";